import { render } from "./InterventionUpdate.vue?vue&type=template&id=5c648306"
import script from "./InterventionUpdate.vue?vue&type=script&lang=js"
export * from "./InterventionUpdate.vue?vue&type=script&lang=js"

import "./InterventionUpdate.vue?vue&type=style&index=0&id=5c648306&lang=css"

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__